import {
  ChangeDetectionStrategy, Component, computed, inject, input, NgZone,
  OnDestroy, OnInit, output, signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { ISablon, ISablonElement } from '../sablon-editoru/sablon.interface';
import { PdksDurumService } from '@uygulamalar/hmi-pdks/services/pdks-durum.service';
import { HmiLookupService } from '@uygulamalar/hmi-pdks/pano/pages/personel/services/hmi-lookup.service';

import { SayacComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/sayac.component';
import { IlerlemeCubuguComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/ilerleme-cubugu.component';
import { IlerlemeHalkaComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/ilerleme-halka.component';
import { GaugeComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/gauge.component';
import { SparklineComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/sparkline.component';
import { BarGrafikComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/bar-grafik.component';
import { DurumDotComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/durum-dot.component';
import { LedGostergeComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/led-gosterge.component';
import { DijitalSaatComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/dijital-saat.component';
import { ButonComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/buton.component';
import { AlanGrafikComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/alan-grafik.component';
import { AnalogSaatComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/analog-saat.component';
import { AvatarComponent as WidgetAvatarComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/avatar.component';
import { BadgeComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/badge.component';
import { CountdownComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/countdown.component';
import { DurumKartComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/durum-kart.component';
import { HavaDurumuComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/hava-durumu.component';
import { IframeComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/iframe.component';
import { IsiHaritasiComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/isi-haritasi.component';
import { KanbanSutunComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/kanban-sutun.component';
import { KronometrComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/kronometr.component';
import { ListeTekrarComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/liste-tekrar.component';
import { LottieComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/lottie.component';
import { MarkdownComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/markdown.component';
import { MiniTabloComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/mini-tablo.component';
import { PastaGrafikComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/pasta-grafik.component';
import { QrKodComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/qr-kod.component';
import { RadarGrafikComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/radar-grafik.component';
import { SeviyeCubuguComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/seviye-cubugu.component';
import { SinyalCubuguComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/sinyal-cubugu.component';
import { SiralamaListesiComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/siralama-listesi.component';
import { SliderComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/slider.component';
import { TabGrupComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/tab-grup.component';
import { TickerComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/ticker.component';
import { ToggleComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/toggle.component';
import { TrafikIsigiComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/trafik-isigi.component';
import { ZamanCizelgesiComponent } from '@uygulamalar/hmi-pano/dashboard/widget-elementler/zaman-cizelgesi.component';
import { WidgetPersonelZetiComponent } from '@uygulamalar/hmi-pdks/dashboard/widget-elementler/personel-zeti.component';
import { WidgetMakineDurumComponent } from '@uygulamalar/hmi-pdks/dashboard/widget-elementler/makine-durum.component';
import { WidgetUretimVerisiComponent } from '@uygulamalar/hmi-pdks/dashboard/widget-elementler/uretim-verisi.component';

const WIDGET_IMPORTS = [
  CommonModule,
  SayacComponent, IlerlemeCubuguComponent, IlerlemeHalkaComponent, GaugeComponent,
  SparklineComponent, BarGrafikComponent, DurumDotComponent, LedGostergeComponent,
  DijitalSaatComponent, ButonComponent,
  AlanGrafikComponent, AnalogSaatComponent, WidgetAvatarComponent, BadgeComponent,
  CountdownComponent, DurumKartComponent, HavaDurumuComponent, IframeComponent,
  IsiHaritasiComponent, KanbanSutunComponent, KronometrComponent, ListeTekrarComponent,
  LottieComponent, MarkdownComponent, MiniTabloComponent, PastaGrafikComponent,
  QrKodComponent, RadarGrafikComponent, SeviyeCubuguComponent, SinyalCubuguComponent,
  SiralamaListesiComponent, SliderComponent, TabGrupComponent, TickerComponent,
  ToggleComponent, TrafikIsigiComponent, ZamanCizelgesiComponent,
  WidgetPersonelZetiComponent, WidgetMakineDurumComponent, WidgetUretimVerisiComponent,
];

@Component({
  selector: 'sablon-renderer',
  standalone: true,
  imports: WIDGET_IMPORTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './sablon-renderer.component.less',
  template: `
    <div class="sr-container" [ngStyle]="containerStil()"
         (click)="olayTetikle('tiklanma')"
         (dblclick)="olayTetikle('ciftTiklama')">
      @if (sablon()?.htmlModu && sablon()?.htmlIcerik) {
        <div class="sr-html-icerik" [innerHTML]="htmlRender()"></div>
      }
      @for (el of gorunurElementler(); track el.id) {
        <div class="sr-element"
             [ngStyle]="elementStil(el)"
             [ngClass]="animasyonSiniflari(el)"
             [class.sr-hover-aktif]="hoverEl === el.id"
             [style.animation-delay]="animasyonGecikme(el)"
             (mouseenter)="el.animasyon?.hover ? onHover(el.id) : 0"
             (mouseleave)="el.animasyon?.hover ? onHover(null) : 0"
             (click)="onElementTikla($event, el)"
             [class.sr-tiklama-aktif]="tiklaEl === el.id"
             [class.sr-duzenlenebilir]="duzenlenebilir() && (el.tur === 'parametre-metin' || el.tur === 'parametre-render')">
          @switch (el.tur) {
            @case ('parametre-metin') {
              <span class="sr-metin" [ngStyle]="metinStil(el)">{{ parametreDeger(el.parametreAnahtari) }}</span>
            }
            @case ('sabit-metin') {
              <span class="sr-metin" [ngStyle]="metinStil(el)">{{ el.icerik }}</span>
            }
            @case ('sekil') {
              <div class="sr-sekil" [ngStyle]="sekilStil(el)"></div>
            }
            @case ('resim') {
              @if (emojiMi(el.resimUrl)) {
                <span class="sr-emoji">{{ el.resimUrl }}</span>
              } @else {
                <img class="sr-resim" [src]="el.resimUrl" loading="lazy" />
              }
            }
            @case ('parametre-render') {
              @if (parametreResimMi(el.parametreAnahtari)) {
                <img class="sr-resim sr-resim-param"
                     [class.sr-resim-tiklanabilir]="true"
                     [src]="parametreResimUrl(el.parametreAnahtari)" loading="lazy"
                     [style.border-radius]="el.stil?.borderRadius ? el.stil.borderRadius + 'px' : ''"
                     (click)="onResimTikla($event, el)" />
              } @else {
                <span class="sr-metin" [ngStyle]="metinStil(el)">{{ parametreDeger(el.parametreAnahtari) }}</span>
              }
            }
            @case ('sayac') {
              <widget-sayac [deger]="parametreDegerSayi(el.parametreAnahtari, el.deger)" [renk]="el.renk || el.stil?.color || '#1890ff'" />
            }
            @case ('ilerleme-cubugu') {
              <widget-ilerleme-cubugu [deger]="parametreDegerSayi(el.parametreAnahtari, el.deger)" [renk]="el.renk || '#1890ff'" />
            }
            @case ('ilerleme-halka') {
              <widget-ilerleme-halka [yuzde]="parametreDegerSayi(el.parametreAnahtari, el.deger)" [renk]="el.renk || '#1890ff'" />
            }
            @case ('gauge') {
              <widget-gauge [deger]="parametreDegerSayi(el.parametreAnahtari, el.deger)" [min]="el.min || 0" [max]="el.max || 100" />
            }
            @case ('sparkline') {
              <widget-sparkline [veriler]="el.veriler || []" [renk]="el.renk || '#1890ff'" />
            }
            @case ('bar-grafik') {
              <widget-bar-grafik [veriler]="barGrafikVerileri(el)" />
            }
            @case ('durum-dot') {
              <widget-durum-dot [durum]="durumDotTipi(el)" />
            }
            @case ('led-gosterge') {
              <widget-led-gosterge [durum]="ledDurum(el)" [renk]="el.renk || '#52c41a'" />
            }
            @case ('dijital-saat') {
              <widget-dijital-saat />
            }
            @case ('buton') {
              <widget-buton [etiket]="el.icerik || 'Buton'" (tiklandi)="onTikla(el.id)" />
            }
            @case ('analog-saat') {
              <widget-analog-saat />
            }
            @case ('countdown') {
              <widget-countdown [hedefTarih]="el.icerik || ''" />
            }
            @case ('kronometr') {
              <widget-kronometr />
            }
            @case ('pasta-grafik') {
              <widget-pasta-grafik [veriler]="el.veriler || []" [etiketler]="el.etiketler || []" />
            }
            @case ('alan-grafik') {
              <widget-alan-grafik [veriler]="el.veriler || []" [renk]="el.renk || '#1890ff'" />
            }
            @case ('radar-grafik') {
              <widget-radar-grafik [veriler]="el.veriler || []" [etiketler]="el.etiketler || []" />
            }
            @case ('isi-haritasi') {
              <widget-isi-haritasi [veriler]="el.veriler || []" />
            }
            @case ('seviye-cubugu') {
              <widget-seviye-cubugu [deger]="parametreDegerSayi(el.parametreAnahtari, el.deger)" [renk]="el.renk || '#1890ff'" />
            }
            @case ('sinyal-cubugu') {
              <widget-sinyal-cubugu [deger]="parametreDegerSayi(el.parametreAnahtari, el.deger)" />
            }
            @case ('durum-kart') {
              <widget-durum-kart [baslik]="el.icerik || ''" [renk]="el.renk || '#1890ff'" [simge]="el.resimUrl || ''" />
            }
            @case ('trafik-isigi') {
              <widget-trafik-isigi [aktif]="trafikIsigiBelirle(el)" />
            }
            @case ('avatar') {
              <widget-avatar [isim]="parametreDeger(el.parametreAnahtari) || el.icerik || ''" [resimUrl]="parametreResimUrl(el.parametreAnahtari) || el.resimUrl || ''" />
            }
            @case ('badge') {
              <widget-badge [deger]="parametreDeger(el.parametreAnahtari) || el.icerik || ''" [renk]="el.renk || '#1890ff'" />
            }
            @case ('ticker') {
              <widget-ticker [metin]="el.icerik || parametreDeger(el.parametreAnahtari) || ''" />
            }
            @case ('qr-kod') {
              <widget-qr-kod [veri]="parametreDeger(el.parametreAnahtari) || el.icerik || ''" />
            }
            @case ('hava-durumu') {
              <widget-hava-durumu />
            }
            @case ('markdown') {
              <widget-markdown [icerik]="el.icerik || parametreDeger(el.parametreAnahtari) || ''" />
            }
            @case ('lottie') {
              <widget-lottie [animasyonUrl]="el.resimUrl || ''" />
            }
            @case ('iframe') {
              <widget-iframe [url]="el.icerik || ''" />
            }
            @case ('liste-tekrar') {
              <widget-liste-tekrar [veriler]="el.veriler || []" />
            }
            @case ('siralama-listesi') {
              <widget-siralama-listesi [veriler]="siralamaVerileri(el)" />
            }
            @case ('mini-tablo') {
              <widget-mini-tablo [veriler]="el.veriler || []" [basliklar]="el.etiketler || []" />
            }
            @case ('kanban-sutun') {
              <widget-kanban-sutun [baslik]="el.icerik || ''" [kartlar]="el.veriler || []" [renk]="el.renk || '#1890ff'" />
            }
            @case ('zaman-cizelgesi') {
              <widget-zaman-cizelgesi [ogeler]="el.veriler || []" />
            }
            @case ('toggle') {
              <widget-toggle [deger]="!!parametreDegerSayi(el.parametreAnahtari, el.deger)" [etiket]="el.icerik || ''" [renk]="el.renk || '#1890ff'" />
            }
            @case ('slider') {
              <widget-slider [deger]="parametreDegerSayi(el.parametreAnahtari, el.deger)" [min]="el.min || 0" [max]="el.max || 100" [renk]="el.renk || '#1890ff'" />
            }
            @case ('tab-grup') {
              <widget-tab-grup [sekmeler]="el.veriler || []" />
            }
            @case ('personel-zeti') {
              <widget-personel-zeti />
            }
            @case ('makine-durum') {
              <widget-makine-durum />
            }
            @case ('uretim-verisi') {
              <widget-uretim-verisi />
            }
          }
        </div>
      }
    </div>

    @if (sablon()?.itemler?.length) {
      <div class="widget-itemler" [class.yatay]="sablon()!.itemler!.length > 3">
        @for (item of sablon()!.itemler; track item.id) {
          <div class="widget-item-kart" (click)="itemTiklandi(item)"
               [style.--item-renk]="item['renk'] || '#1890ff'">
            @if (item['simge']) { <span class="widget-item-simge">{{ item['simge'] }}</span> }
            @if (item['baslik']) { <span class="widget-item-baslik">{{ item['baslik'] }}</span> }
          </div>
        }
      </div>
    }
  `,
})
export class SablonRendererComponent extends FikoYTKokBilesenComponent implements OnInit, OnDestroy {
  override sanitizer = inject(DomSanitizer);
  private zone = inject(NgZone);
  pdks = inject(PdksDurumService);
  lookup = inject(HmiLookupService);

  sablon = input<ISablon>();
  parametreDegerleri = input<Record<string, any>>({});
  duzenlenebilir = input(false);
  olaylarAktif = input(false);
  parametreTiklandi = output<{ parametreAnahtari: string; mevcutDeger: any }>();
  resimDegisti = output<{ parametreAnahtari: string; dosya: File; objectUrl: string }>();

  veri = signal<any>(null);
  yukleniyor = signal(false);
  hoverEl: string | null = null;
  tiklaEl: string | null = null;

  veriParametreleri = computed(() => {
    const pDegerleri = this.parametreDegerleri();
    const v = this.veri();
    if (!v) return pDegerleri;
    const veriObj = typeof v === 'object' && !Array.isArray(v) ? v : { deger: v };
    return { ...veriObj, ...pDegerleri };
  });

  private _tiklaTimer: any;
  private pollingInterval: any;
  private soketTemizle: (() => void) | null = null;
  private readonly emojiRegex = /^[\p{Emoji_Presentation}\p{Extended_Pictographic}]+$/u;

  constructor() { super(); }

  ngOnInit() {
    if (this.sablon()?.veriKaynagi) {
      this.veriYukle();
      this.pollingKur();
      this.soketBagla();
    }
  }

  private async veriYukle() {
    const s = this.sablon();
    const vk = s?.veriKaynagi;
    if (!vk) return;
    this.yukleniyor.set(true);
    try {
      let sonuc: any = null;
      switch (vk.mod) {
        case 'aggregate': {
          const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.hareketler.aggregate' });
          let pipeline = vk.pipeline;
          if (!pipeline && vk.vt) pipeline = [{ $match: { vt: vk.vt } }];
          if (!pipeline) break;
          istek.parametreler = { aggregate: pipeline };
          await istek.isteSync();
          sonuc = istek.cevap?.sonuc;
          if (vk.donusumFunc) {
            try { sonuc = new Function('veri', 'sablon', vk.donusumFunc)(sonuc, s); } catch {}
          }
          break;
        }
        case 'sabit':
          sonuc = vk.sabitVeri ?? null;
          break;
        case 'soket':
          break;
        case 'hesaplama':
          if (vk.piFunc) {
            try { sonuc = new Function('veri', 'sablon', vk.piFunc)(null, s); } catch {}
          }
          break;
      }
      this.veri.set(sonuc);
      this.olayTetikle('yenilendi');
    } catch {} finally {
      this.yukleniyor.set(false);
    }
  }

  private soketBagla() {
    const s = this.sablon();
    const vk = s?.veriKaynagi;
    const olay = vk?.soketOlay || vk?.soketTetik;
    if (!olay) return;
    const io = (window as any).FikoYT?.io;
    if (!io?.on) return;

    const handler = (payload: any) => {
      if (vk!.soketFiltre) {
        const eslesiyor = Object.entries(vk!.soketFiltre).every(([k, v]) => payload?.[k] === v);
        if (!eslesiyor) return;
      }
      this.zone.run(() => {
        if (vk!.mod === 'soket' && vk!.soketOlay) {
          this.veri.set(payload);
          this.olayTetikle('yenilendi');
        } else {
          this.veriYukle();
        }
      });
    };

    io.on(olay, handler);
    this.soketTemizle = () => io.off(olay, handler);
  }

  private pollingKur() {
    const aralik = this.sablon()?.veriKaynagi?.yenilemeAraligi;
    if (!aralik || aralik <= 0) return;
    this.zone.runOutsideAngular(() => {
      this.pollingInterval = setInterval(() => {
        this.zone.run(() => this.veriYukle());
      }, aralik * 1000);
    });
  }

  olayTetikle(olayAdi: string) {
    if (!this.olaylarAktif()) return;
    const kod = this.sablon()?.olaylar?.[olayAdi];
    if (!kod) return;
    try {
      const fn = new Function('veri', 'sablon', 'router', 'bildirim', 'guncelle', kod);
      fn(this.veri(), this.sablon(), this.router, this.bildirimFn(), this.guncelleFn());
    } catch (e) {
      console.warn('Olay hatasi:', olayAdi, e);
    }
  }

  private bildirimFn(): (mesaj: string, tip?: string) => void {
    return (mesaj: string, tip: string = 'basarili') => {
      const tipMap: Record<string, string> = { basarili: 'success', uyari: 'warning', hata: 'error' };
      this.nzNotification.create(tipMap[tip] || 'info', '', mesaj);
    };
  }

  private guncelleFn(): (veri: any) => void {
    return (yeniVeri: any) => {
      this.veri.set(yeniVeri);
    };
  }

  itemTiklandi(item: any) {
    if (!this.olaylarAktif()) return;
    const kod = item?.olaylar?.tiklanma;
    if (!kod) return;
    try {
      const fn = new Function('veri', 'sablon', 'router', 'bildirim', 'guncelle', kod);
      fn(item, this.sablon(), this.router, this.bildirimFn(), this.guncelleFn());
    } catch (e) {
      console.warn('Item olay hatasi:', item?.id, e);
    }
  }

  onHover(elId: string | null) {
    this.hoverEl = elId;
    this.CD.markForCheck();
  }

  onElementTikla(event: MouseEvent, el: ISablonElement) {
    if (this.duzenlenebilir() && (el.tur === 'parametre-metin' || el.tur === 'parametre-render') && el.parametreAnahtari) {
      event.stopPropagation();
      this.parametreTiklandi.emit({
        parametreAnahtari: el.parametreAnahtari,
        mevcutDeger: this.veriParametreleri()?.[el.parametreAnahtari],
      });
      return;
    }
    if (el.animasyon?.tiklama) this.onTikla(el.id);
    if (el.tiklanmaKodu && this.olaylarAktif()) {
      try {
        const fn = new Function('veri', 'el', 'router', 'bildirim', el.tiklanmaKodu);
        fn(this.veri(), el, this.router, this.bildirimFn());
      } catch {}
    }
  }

  htmlRender(): SafeHtml {
    const s = this.sablon();
    if (!s?.htmlIcerik) return '';
    let html = s.htmlIcerik;
    const mergedP = this.veriParametreleri();
    html = html.replace(/\{\{(\w+)\}\}/g, (_, anahtar) => {
      const deger = mergedP?.[anahtar];
      if (deger == null) return '';
      return String(deger);
    });
    if (s.cssIcerik) {
      html = `<style>${s.cssIcerik}</style>${html}`;
    }
    if (s.jsIcerik && this.olaylarAktif()) {
      try {
        const fn = new Function('p', s.jsIcerik);
        fn(mergedP || {});
      } catch {}
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  onTikla(elId: string) {
    if (this._tiklaTimer) clearTimeout(this._tiklaTimer);
    this.tiklaEl = null;
    this.CD.markForCheck();
    setTimeout(() => {
      this.tiklaEl = elId;
      this.CD.markForCheck();
      this._tiklaTimer = setTimeout(() => {
        this.tiklaEl = null;
        this.CD.markForCheck();
      }, 700);
    });
  }

  containerStil(): Record<string, string> {
    const s = this.sablon();
    if (!s) return {};
    const stil: Record<string, string> = {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      'aspect-ratio': (s.genislik || 520) + ' / ' + (s.yukseklik || 300),
      'border-radius': '8px',
    };
    if (s.arkaPlan) {
      const ap = s.arkaPlan;
      if (ap.tur === 'renk') stil['background-color'] = ap.deger;
      else stil['background'] = ap.deger;
      if (ap.tur === 'resim') {
        stil['background-image'] = `url(${ap.deger})`;
        stil['background-size'] = 'cover';
        stil['background-position'] = 'center';
      }
    }
    return stil;
  }

  elementStil(el: ISablonElement): Record<string, string> {
    const s = this.sablon();
    const containerW = s?.genislik || 520;
    const containerH = s?.yukseklik || 300;
    const stil: Record<string, string> = {
      position: 'absolute',
      left: el.x + '%',
      top: el.y + '%',
      display: 'flex',
    };
    if (el.genislik) stil['width'] = (el.genislik / containerW * 100) + '%';
    if (el.yukseklik) stil['height'] = (el.yukseklik / containerH * 100) + '%';
    if (el.katman != null) stil['z-index'] = '' + el.katman;
    if (el.stil?.opacity != null) stil['opacity'] = '' + el.stil.opacity;
    if (el.stil?.rotate) stil['transform'] = 'rotate(' + el.stil.rotate + 'deg)';
    const ta = el.stil?.textAlign ?? 'left';
    stil['justify-content'] = ta === 'center' ? 'center' : ta === 'right' ? 'flex-end' : 'flex-start';
    const va = el.stil?.verticalAlign ?? 'top';
    stil['align-items'] = va === 'center' ? 'center' : va === 'bottom' ? 'flex-end' : 'flex-start';
    return stil;
  }

  metinStil(el: ISablonElement): Record<string, string> {
    const stil: Record<string, string> = {};
    const s = el.stil;
    if (!s) return stil;
    if (s.fontSize) stil['font-size'] = s.fontSize + 'px';
    if (s.fontWeight) stil['font-weight'] = s.fontWeight;
    if (s.fontFamily) stil['font-family'] = s.fontFamily;
    if (s.color) stil['color'] = s.color;
    if (s.textAlign) stil['text-align'] = s.textAlign;
    if (s.letterSpacing) stil['letter-spacing'] = s.letterSpacing + 'px';
    if (s.lineHeight) stil['line-height'] = '' + s.lineHeight;
    if (s.shadow) stil['text-shadow'] = s.shadow;
    return stil;
  }

  sekilStil(el: ISablonElement): Record<string, string> {
    const stil: Record<string, string> = { width: '100%', height: '100%' };
    const s = el.stil;
    if (s?.fill) stil['background-color'] = s.fill;
    if (s?.stroke) stil['border'] = (s.strokeWidth ?? 1) + 'px solid ' + s.stroke;
    switch (el.sekilTuru) {
      case 'daire': stil['border-radius'] = '50%'; break;
      case 'dikdortgen': if (s?.borderRadius) stil['border-radius'] = s.borderRadius + 'px'; break;
    }
    return stil;
  }

  parametreDeger(anahtar: string | undefined): string {
    if (!anahtar) return '';
    const deger = this.veriParametreleri()?.[anahtar];
    if (deger == null) return '';
    if (typeof deger === 'boolean') return deger ? 'Evet' : 'Hayir';
    return '' + deger;
  }

  gorunurElementler(): ISablonElement[] {
    return (this.sablon()?.elementler ?? []).filter(e => e.gorunur !== false);
  }

  animasyonSiniflari(el: ISablonElement): string[] {
    const a = el.animasyon;
    if (!a) return [];
    const cls: string[] = [];
    if (a.giris) cls.push('sr-anim-giris-' + a.giris);
    if (a.surekli) cls.push('sr-anim-surekli-' + a.surekli);
    if (a.hover) cls.push('sr-anim-hover-' + a.hover);
    if (a.tiklama) cls.push('sr-anim-tikla-' + a.tiklama);
    return cls;
  }

  animasyonGecikme(el: ISablonElement): string {
    const a = el.animasyon;
    if (!a?.girisGecikme) return '';
    return a.girisGecikme + 'ms';
  }

  onResimTikla(event: MouseEvent, el: ISablonElement) {
    event.stopPropagation();
    const url = this.parametreResimUrl(el.parametreAnahtari);
    if (this.duzenlenebilir()) {
      const inp = document.createElement('input');
      inp.type = 'file';
      inp.accept = 'image/*';
      inp.onchange = () => {
        const dosya = inp.files?.[0];
        if (!dosya || !el.parametreAnahtari) return;
        const objectUrl = URL.createObjectURL(dosya);
        this.resimDegisti.emit({ parametreAnahtari: el.parametreAnahtari, dosya, objectUrl });
        this.CD.markForCheck();
      };
      inp.click();
    } else if (url) {
      window.open(url, '_blank');
    }
  }

  parametreResimMi(anahtar: string | undefined): boolean {
    if (!anahtar) return false;
    const deger = this.veriParametreleri()?.[anahtar];
    if (!deger) return false;
    if (typeof deger === 'string') return deger.startsWith('blob:') || deger.startsWith('data:') || deger.startsWith('http');
    return !!(deger?.objectUrl || deger?.url);
  }

  parametreResimUrl(anahtar: string | undefined): string {
    if (!anahtar) return '';
    const deger = this.veriParametreleri()?.[anahtar];
    if (!deger) return '';
    if (typeof deger === 'string') return deger;
    return deger?.objectUrl || deger?.url || '';
  }

  emojiMi(url: string | undefined): boolean {
    if (!url || url.length > 8) return false;
    return this.emojiRegex.test(url);
  }

  parametreDegerSayi(anahtar: string | undefined, varsayilan?: number): number {
    if (!anahtar) return varsayilan ?? 0;
    const deger = this.veriParametreleri()?.[anahtar];
    return typeof deger === 'number' ? deger : Number(deger) || (varsayilan ?? 0);
  }

  barGrafikVerileri(el: ISablonElement): { etiket: string; deger: number; renk?: string }[] {
    if (!el.veriler?.length) return [];
    return el.veriler.map((d, i) => ({
      etiket: el.etiketler?.[i] || '' + (i + 1),
      deger: d,
      renk: el.renk,
    }));
  }

  siralamaVerileri(el: ISablonElement): { sira: number; isim: string; deger: number; renk?: string }[] {
    if (!el.veriler?.length) return [];
    return (el.veriler as any[]).map((d, i) => ({
      sira: i + 1,
      isim: el.etiketler?.[i] || '' + (i + 1),
      deger: typeof d === 'number' ? d : Number(d) || 0,
      renk: el.renk,
    }));
  }

  durumDotTipi(el: ISablonElement): 'aktif' | 'uyari' | 'hata' | 'pasif' {
    const v = this.parametreDegerSayi(el.parametreAnahtari, el.deger);
    if (v >= 1) return 'aktif';
    if (v < 0) return 'hata';
    return 'pasif';
  }

  ledDurum(el: ISablonElement): 'acik' | 'kapali' | 'yanip-sonen' {
    const v = this.parametreDegerSayi(el.parametreAnahtari, el.deger);
    if (v >= 2) return 'yanip-sonen';
    if (v >= 1) return 'acik';
    return 'kapali';
  }

  trafikIsigiBelirle(el: ISablonElement): 'kirmizi' | 'sari' | 'yesil' {
    const v = this.parametreDegerSayi(el.parametreAnahtari, el.deger);
    if (v >= 2) return 'yesil';
    if (v >= 1) return 'sari';
    return 'kirmizi';
  }

  ngOnDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    this.soketTemizle?.();
    this.soketTemizle = null;
    super.ngOnDestroy();
  }
}
